import { defineMessages } from 'react-intl';

const messages = defineMessages({
  GeneralSetting: 'GeneralSetting',
  WithoutRequiredAuthorizationWarningFilter: 'Filter on missing authorizations',
  WithoutMissingAuthorizations: 'WithoutMissingAuthorizations',
  WithMissingAuthorizations: 'WithMissingAuthorizations',
  Authorization: 'Authorization',
  PartnerRequiredAuthorizationMissing:
    'The required authorization {authorization} is missing for the partner of this relation.',
  PartnerRequiredAuthorizationExpiring:
    'The required authorization {authorization} is going to expire on {expiryDate} for the partner of this relation.',
  PartnerRequiredAuthorizationExpired:
    'The required authorization {authorization} has expired on {expiryDate} for the partner of this relation.',
  RequiredAuthorizationMissing: 'The required authorization {authorization} is missing.',
  RequiredAuthorizationExpiring:
    'The required authorization {authorization} is going to expire on {expiryDate}.',
  RequiredAuthorizationExpired:
    'The required authorization {authorization} has expired on {expiryDate}.',
  ExportToExcelStarted: 'Export to Excel started',
  Share: 'Share',
  AssignedTo: 'Assigned to',
  Deadline: 'Deadline',
  ExecutionDate: 'Execution date',
  ExecutionDuration: 'Execution duration',
  RemainingDuration: 'Remaining duration',
  RemainingDurationTooltip:
    'The remaining duration is calculated as the execution duration minus the total duration of all time registrations on this task and its subtasks.',
  RestoreOriginalDeadline: 'Reset to original deadline: {originalDeadline}',
  NoDeadline: 'No deadline',
  NoExecutionDate: 'No execution date',
  CompletedDate: 'Completed on',
  TaskStatus: 'Status',
  DeadlineFrom: 'From',
  DeadlineUntil: 'Until',
  DeadlineFromPlaceholder: 'Deadline from',
  DeadlineUntilPlaceholder: 'Deadline until',
  NoTasksFound: 'No tasks found',
  SelectTask: 'Select a task',
  Relation: 'Relation',
  TaskOverview: 'Task overview',
  SubTaskExecutionDurationProgress: 'Execution time completed: {completed} of {total}',
  SubTaskExecutionDurationComplete: 'Total execution time: {total}',
  SubTaskNoExecutionDuration: 'No execution duration specified for this subtask',
  Unassigned: 'Unassigned',
  HideHistory: 'Hide history',
  ShowHistory: 'Show history',
  EditDocument: 'Edit document',
  Via: 'Via',
  ExportAuthorizations: 'Export authorizations',
  UpdateAssignedUserQueued:
    'The assigned users for the selected tasks will be updated in the background.',
  ChangeAssignedUser: 'Change assigned user',
  'Same as parent': 'Same as parent',
  User: 'User',
  Into: 'Into',
  On: 'On',
  All: 'All',
  From: 'From',
  To: 'To',
  Or: 'or',
  History: 'History',
  ThisMonth: 'This month',
  NextMonth: 'Next month',
  ThisQuarter: 'This quarter',
  NextQuarter: 'Next quarter',
  ThisYear: 'This year',
  OpenInTaskboard: 'Open this task in the task board',
  ShowDateDone: 'Show completed date',
  ShowDeadline: 'Show deadline',
  ShowExecutionDate: 'Show execution date',
  ShowAssignedTo: 'Show assigned to',
  CountTasksSelected: 'Selected {count} / {total} tasks',
  GlobalActions: 'Global actions',
  ChangeTaskStatus: 'Change task status',
  ChangeMainTaskStatus: 'Change main task status',
  ChangeSubtaskStatus: 'Change subtask status',
  ChangeTodoStatus: 'Change todo status',
  ChangeDeadline: 'Change deadline',
  ChangeExecutionDate: 'Change execution date',
  ChangeSubtaskDeadline: 'Change subtask deadline',
  Subtask: 'Subtask',
  SelectASubtask: 'Select a subtask',
  SendEmail: 'Send email',
  AutomaticMailTooltip: 'An email will be sent automatically on the deadline',
  Subject: 'Subject',
  UpdateTaskStatusQueued:
    'The task status for the selected task will be updated shortly. Click here to view its progress.',
  PlaceholdersWillBeResolvedByAdminPulse: 'The visible placeholders will be resolved by AdminPulse',
  Attachments: 'Attachments',
  MsgEmailAttachmentUploadFailed: 'An error occurred when uploading the email attachment',
  NoEmailTemplateFoundInLanguage: 'No email template was found in {language}',
  EmailContentRequired: 'The email must have content.',
  ExportToExcel: 'Export to Excel',
  Tasks: 'Tasks',
  TaskList: 'Task list',
  Task: 'Task',
  TaskType: 'Task type',
  Actions: 'Actions',
  RelationType: 'Relation type',
  RegistratedTime: 'Registrated time',
  SubTask: 'Sub task',
  AddRegistration: 'Add registration',
  Documents: 'Documents',
  ModifiedAt: 'Modified at',
  ModifiedBy: 'Modified by',
  CreatedAt: 'Created at',
  CreatedBy: 'Created by',
  AssignedToMe: 'Assigned to me',
  NotAssignedToMe: 'Not assigned to me',
  AddOneTimeTask: 'Add one time task',
  ColumnConfig: 'Configure columns',
  SelectColumns: 'Select columns',

  ThisTaskCannotBeOpenedInTaskBoard:
    'This task cannot be opened in the taskboard. It has been completed and the deadline has passed.',
  AToDoCannotBeOpenedInTaskBoard: 'A to-do cannot be opened in the taskboard.',
  UseTaskTemplate: 'Use task template',
  Description: 'Description',
  MarkAsInapplicable: 'Mark as inapplicable',
  MarkAsApplicable: 'Mark as applicable',
  Remark: 'Remark',
  TaskScheduleRemark: 'Task schedule remark',
  CreateNewToDo: 'Create new to-do',
  ToDoCreated: 'To-do created',
  ToDo: 'To-do',
  ToDos: "To-do's",
  SubTasks: 'Sub tasks',
  MainTasks: 'Main tasks',
  FilterOnToDos: "Filter on to-do's",
  FilterOnMainTasks: 'Filter on main tasks',
  FilterOnSubTasks: 'Filter on sub tasks',
  Save: 'Save',
  MainTask: 'Main task',
  TimeRegistrations: 'Time registrations',
  NoRegistrationsForThisTask: 'No time registrations recorded for this task.',
  CreateTimeRegistration: 'Create time registration',
  PauseTimer: 'Pause timer',
  StartTimer: 'Start timer',
  CountRegistrationsForDuration:
    '{count} registrations were made for this task for a total duration of {duration}',
  CountRegistrations: '{count} registration(s) were made for this task.',
  PriceListItem: 'Pricelist item',
  NoPriceListItemsFound: 'No pricelist items found',
  Duration: 'Duration',
  Employee: 'Employee',
  Date: 'Date',
  ThisTaskHasCountSubTasks: 'This task has {count} subtasks:',
  Blocked: 'Blocked',
  Block: 'Block',
  Unblock: 'Unblock',
  ViewTask: 'View task',
  Delete: 'Delete',
  DeleteTask: 'Delete task',
  DeleteMainTaskConfirmationMsg:
    'Are you sure you want to delete this task? All subtasks associated with this task will be deleted as well.',
  DeleteTaskConfirmationMsg: 'Are you sure you want to delete this task?',
  TaskDeleted: 'Task deleted',
  ChangeTaskDeadline: 'Change task deadline',
  ChangeTaskExecutionDate: 'Change task execution date',
  UpdateTaskDeadlineQueued:
    'The deadline for the selected tasks will be updated shortly. Click here to view its progress.',
  UpdateTaskExecutionDateQueued:
    'The execution date for the selected tasks will be updated shortly. Click here to view its progress.',
  NewRegistration: 'New registration',
  NewRegistrationsQueued: 'New registrations will be created shortly.',
  OpenTaskDetails: 'Open task details',
  Inapplicable: 'Inapplicable',
  Quantity: 'Quantity',
  DownloadAttachment: 'Download attachment',
  OpenDocument: 'Open document',
  Open: 'Open',
  Pending: 'Pending',
  Error: 'Error',
  DeleteAttachment: 'Delete attachment',
  AddDocument: 'Add document',
  DeleteAttachmentConfirmationMsg: 'Are you sure you want to delete this attachment?',
  UnlinkDocument: 'Unlink document',
  UnlinkDocumentConfirmationMsg:
    'Are you sure you want to unlink this document from the task? The document itself will not be deleted.',
  TaskGlobalActionsTooltip: 'Select one or more tasks to execute a global action on these tasks.',
  TaskDashboard: 'Task dashboard',
  ChartType: 'Chart type',
  ShowQuantitiesChart: 'Show quantities chart',
  ShowPercentagesChart: 'Show percentages chart',
  Quantities: 'Quantities',
  Percentages: 'Percentages',
  Total: 'Total',
  Tags: 'Tags',
  FilterPeriodicity: 'Filter periodicity',
  NoPeriodicity: 'No periodicity',
  TaskPeriodicityLine: 'Periodicity line',
  SelectPeriodicityFirst: 'Select a periodicity first',
  NoPeriodicityLines: 'No periodicity lines',
  ClearFilter: 'Clear filter',

  TaskOverviewNoTaskSelectedDescription:
    'This screen provides an overview of the planned tasks. \r\nYou can see the progress of the subtasks and quickly change the status by clicking the colored circles or by clicking the arrow next to it and selecting the new status.',
  TaskOverviewNoTaskSelectedSelectTask:
    'To begin working with this overview, you first need to select a task:',
  TasksAssignedTo: 'Tasks assigned to',
  RelationsAssignedTo: 'Relations assigned to',
  ChooseTaskFirst: 'Choose task above',
  ShowParameters: 'Show parameters',
  FilledOut: 'Filled out',
  NotFilledOut: 'Not filled out',

  SendEmailQueued:
    'Emails for the selected relations are being sent. Click here to view its progress.',
  SentEmails: 'Sent emails',
  Recipients: 'Recipients',
  Preview: 'Preview',
  EmailSent: 'Email sent',

  ResetFilters: 'Reset filters',
  HideCompletedTasks: 'Hide fully completed tasks',
  RelationLabels: 'Relation labels',
  DocumentsOfTheFollowingTypeWillBeLinkedIfPresent:
    'Documents of the following type will be attached to the email if linked to task:',
  ChooseDocumentInAdminPulse: 'Choose document in AdminPulse',
  Assignment: 'Assignment',
  DefaultAssignment: 'Default assignment',
  Status: 'Status',
  AllTasks: 'All tasks',
  AllUsers: 'All users',
  TasksWithoutTemplate: 'Tasks without template',
  TaskCreatedOnLabel: 'Created on {timestamp} by {creationSource}',
  TaskCreated: 'Task created',
  FilterTaskTemplateNotFound:
    'This filter does not work because the task template does not exist anymore',
  GenerateDocuments: 'Generate documents',
  GenerateDocumentsQueued:
    'The documents are being generated for the selected relations. Click here to view its progress.',
  ResetDeadline: 'Reset deadline',
  UpdateFor: 'Update for',
  MainTaskAndAllSubtasks: 'Main task and all subtasks',
  OnlyMainTask: 'Only main task',
  SubTaskDeadlineResetInfo:
    'The deadlines will be reset based on the deadline of the main task and the deviation from the template.',
  MainTaskDeadlineResetInfo:
    'The deadlines will be reset based on the original reference date/year and the current task periodicity settings.',
  ReferenceYear: 'Reference year',
  SendMail: 'Send mail',
  OpenMailHistory: 'Open mail history',
  TimeRegistrationIsNotPossibleTaskTypeCondition:
    'Time registration is not possible on a task of type condition',

  NewTask: 'New task',

  ItemFromPricelist: 'Item from pricelist',

  UserDefinedInTaskTemplate: 'User defined in task template',

  MarkAsRejected: 'Mark as rejected',
  MarkAsNotRejected: 'Mark as not rejected',
  Rejected: 'Rejected',
  System: 'System',
  BackgroundJobQueued: 'Job started',

  EnterTag: 'Enter tag',
  AddTaskTags: 'Add tags to tasks',
  RemoveTaskTags: 'Remove tags from tasks',
  NoSignableDocumentsLinkedToTask: 'No signable documents linked to this task',
  SelectDocuments: 'Select documents',
  SendDocumentsLinkedToTaskOutForSignature: 'SendDocumentsLinkedToTaskOutForSignature',
  ShowTasksWhereSelectedUserIsNextInLine: 'Show tasks where selected user is next in line',
  ShowTasksWhereSelectedUserIsNextInLineTooltip:
    'When you have selected a user, this filter will only show the tasks where that user is next in line and can start working on the tasks.',
  Interactions: 'Interactions',
  Interaction: 'Interaction',
  Note: 'Note',
  PhoneCall: 'Phone call',
  Email: 'Email',
  Appointment: 'Meeting report',
  DeleteinteractionLink: 'Remove interaction link',
  DeleteInteractionLinkConfirmationMsg:
    'Are you sure you want to remove the link to this interaction?',
  Field: 'Field',
  ChangeMainTaskField: 'Change main task field',
  OverrideReferenceYear: 'Override reference year',
  ClearReferenceYear: 'Clear reference year',
  RecalculateReferenceYear: 'Recalculate reference year',

  ChangedFieldFrom: '{property} was changed from',
  ChangedFieldTo: 'to',
  ChangedField: '{property} was changed from {originalValue} to {currentValue}',
  Shared: 'Shared',
  SharedWith: 'with',
  SubtaskWithTaskflowBilling: 'Subtask with taskflow billing',
  CustomerCode: 'Customer code',

  HoursAbbreviated: 'h',
  MinutesAbbreviated: 'm',

  TaskProgressPerEmployee: 'Task progress per employee',
  ShowByExecutionDuration: 'Show by execution duration',
  TaskProgressNoTaskSelectedDescription:
    'This screen shows the progress of each employee on the subtasks of a main task. \r\nFor each employee you can see how many subtasks have been completed, optionally weighted by the execution duration.',
  TaskProgressNoTaskSelectedSelectTask:
    'To begin working with this overview, you first need to select a task:',
  TaskProgressEmployeeCount: '{count} employees',
  TaskProgressNoEmployees: 'No employees',
  TaskProgressNoPlannedDuration: '{count} tasks do not have a planned duration',
});

export default messages;
